import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Box, TextField,Typography, Button } from '@material-ui/core';
import Paper from '@material-ui/core/Paper'

import { createPaymentIntents } from '../../../walletApi'
import { isAuthenticated } from "../../../../auth";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(1),
      width: theme.spacing(50),
      height: theme.spacing(50),
    },
  },
  cardSpace:{marginTop: "250px", margin: "auto"}
}));

export default function EnterAmount({dataHandler}) {
  
  const { token } = isAuthenticated();
  const classes = useStyles();
  const [paymentAmount, setPaymentAmount] = useState(0)

  const handleSubmit = (e) =>{
    e.preventDefault()

    const intentsData = {
      amount:parseInt(paymentAmount), 
      paymentMethodAllowed:["card", "gcash"], 
      currency:"PHP", 
      description:"Top UP amount"}

    createPaymentIntents(intentsData, token).then((data =[]) =>{
      if (data && data.error) {
          console.log(data.error) 
      } else {
        dataHandler(data.data.attributes)
        
      }
    })
  }

  return (
    <Container>
      <div className={classes.root}>
        <Box className={classes.cardSpace}>
              <Paper elevation={3}>
                <Typography> Enter Amount</Typography>
                <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                  <TextField 
                    id="outlined-basic" 
                    label="Enter amount" 
                    variant="outlined"
                    value={paymentAmount}
                    onChange={(e) => setPaymentAmount(e.target.value)} 
                  />
                  <br/>            
                  <Button
                    type='submit' 
                    variant="contained" 
                    color="secondary"
                  >
                    Next
                  </Button>
                </form>
              </Paper>
        </Box>
      </div>
    </Container>
  );
}
